import { useState, useEffect } from "react";

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, Link } from 'react-router-dom'
import { loginUser, ForgotPassword, ResetPassword } from "../features/auth/authSlice";
import { selectAuthError, selectAuthStatus, selectCurrentUser } from "../features/auth/authSlice";
import { fetchagentmarkup } from "../features/auth/authSlice";

import {
    Facebook, Twitter, Instagram, Linkedin, Chrome,
    Eye, EyeOff,
} from "lucide-react";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { toast } from 'react-hot-toast';
import { getSiteName } from "../api/axios";
import { maskPhone } from "../utils/maskPhone";
import {
    Plane,
    Hotel,
    ChevronRight,
    Search,
    BadgeDollarSign,
    Zap,
    ShieldCheck,
    Headphones,
    Globe,
    Wifi,
    Tag,
    RefreshCcw,
    CheckCircle2,
    Star,
} from "lucide-react";

// ── Data ──────────────────────────────────────────────────────────────────────
const services = [
    {
        icon: Plane,
        title: "Flight Booking",
        desc: "Book domestic and international flights with all major airlines for a seamless, comprehensive travel experience.",
    },
    // {
    //   icon: Package,
    //   title: "Holiday Packages",
    //   desc: "Explore holiday packages at the lowest prices, offering exceptional value for unforgettable travel experiences.",
    // },
    {
        icon: Hotel,
        title: "Hotel Booking",
        desc: "Book hotels of all categories, from budget to luxury, ensuring options for every traveler's needs and preferences.",
    },
    // {
    //   icon: FileCheck,
    //   title: "Visa Services",
    //   desc: "Get expert visa assistance services with personalized guidance, ensuring hassle-free visa applications for all destinations.",
    // },
    // {
    //   icon: Bus,
    //   title: "Bus Booking",
    //   desc: "Access the lowest bus fares with a wide selection of bus types, ensuring affordable and comfortable travel options.",
    // }
];

const whyUs = [
    { icon: Globe, label: "One Portal for Flights, Hotels, Holidays" },
    { icon: Wifi, label: "Real-Time Rates, Availability & Instant Booking" },
    { icon: Star, label: "Exclusive B2B Deals for Travel Agents" },
    { icon: Plane, label: "Faster Quotations with Easy Online Booking" },
    { icon: Tag, label: "Dedicated Relationship Manager & Booking Support" },
    { icon: RefreshCcw, label: "Simplified Cancellations & Refund Tracking" },
    { icon: RefreshCcw, label: "Custom White-Label Travel Portals" },
];

const highlights = [
    { icon: BadgeDollarSign, label: "Best Prices Guaranteed" },
    { icon: ShieldCheck, label: "100% Reliable" },
    { icon: Zap, label: "Quick Response" },
    { icon: Headphones, label: "Friendly Support" },
];

const navLinks = ["Home", "About Us", "Agent", "White Label", "API/XML", "Supplier", "Contact Us"];

// const footerCompany = ["Home", "About Us", "Contact"];
// const footerProduct = ["Flight Booking", "Hotel Booking", "Bus Booking", "Travel Package", "Visa Service"];
// const footerPolicies = ["Terms & Conditions", "FAQ", "Privacy Policy"];

const footerCompany = [
    { id: 1, name: "Home", href: "/" },
    { id: 2, name: "About Us", href: "/cms/about-us" },
    { id: 3, name: "Contact Us", href: "/cms/contact-us" }
];

const footerProduct = [
    { id: 1, name: "Flight Booking", href: "/flight" },
    { id: 2, name: "Hotel Booking", href: "/hotel" },
    // { id: 3, name: "Holiday Booking", href: "/Holidays" },
    // { id: 4, name: "Umrah/Hajj", href: "/Holidays/umrah" }
];

const footerPolicies = [
    { id: 1, name: "Terms & Conditions", href: "/cms/terms-conditions" },
    { id: 2, name: "FAQ", href: "/cms/faq" },
    { id: 3, name: "Privacy Policy", href: "/cms/privacy-policy" },
    // { id: 3, name: "A Members Only Wholesale Booking Site", href: "/cms/a-members-only-wholesale-booking-site" }
];

export default function ZiaTravels() {
    const [activeTab, setActiveTab] = useState("login");
    const [ShowForgot, setShowForgot] = useState(false);
    const user = useSelector(selectCurrentUser)

    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

    const [formData, setFormData] = useState({
        email: '',
        password: '',
    })

    const [formDataReset, setFormDataReset] = useState({
        "email": formData?.email,
        "token": "",
        "otp": "",
        "password": "",
        "password_confirmation": "",
        "phone": ""
    })
    useEffect(() => {
        if (user) {
            navigate('/flight')
        }
    }, []);

    const { ForgotPasswordstatus, ForgotPasswordData, ResetPasswordstatus, ResetPasswordData } = useSelector((state) => state.auth);

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const status = useSelector(selectAuthStatus)
    const error = useSelector(selectAuthError)

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })
    }
    const handleChangeResetPassword = (e) => {
        setFormDataReset({
            ...formDataReset,
            [e.target.name]: e.target.value,
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            const resultAction = await dispatch(loginUser(formData))
            if (resultAction.payload.status) {
                toast.success('Login successfully');
                if (loginUser.fulfilled.match(resultAction)) {
                    const markup = await dispatch(fetchagentmarkup())
                    localStorage.setItem('agent_markup', JSON.stringify(markup.payload.data.data))
                    navigate('/flight')
                }
            } else {
                toast.error(resultAction.payload.message);
            }
        } catch (error) {
            toast.error(error.message || 'Something went wrong');
        }

    }
    const handleforgotPassword = async (e) => {
        e.preventDefault()
        const CheckUser = {
            "email": formData?.email,
        }
        if (formData.email === '') {
            toast.error('Please enter email id', { autoClose: 2000 });
            return false;
        }
        dispatch(ForgotPassword(CheckUser));
    }
    // console.log("getSiteName:-", getSiteName);

    useEffect(() => {
        if (ForgotPasswordstatus === 'success' && ForgotPasswordData?.status?.success === true) {
            setFormDataReset({
                ...formDataReset,
                ['email']: formData?.email,
                ['reset_token']: ForgotPasswordData?.token,
                ['phone']: ForgotPasswordData?.mobile
            })
            toast.success(ForgotPasswordData?.message, { autoClose: 2000 });
        } else if (ForgotPasswordstatus === 'success' && ForgotPasswordData?.status?.success === false) {
            toast.error(ForgotPasswordData?.message, { autoClose: 2000 });
        }
    }, [ForgotPasswordData, ForgotPasswordstatus]);

    const SubmitforgotPassword = async (e) => {
        e.preventDefault()
        if (formDataReset.otp === '') {
            toast.error('Please enter OTP', { autoClose: 2000 });
            return false;
        }
        if (formDataReset.password === '') {
            toast.error('Please new password', { autoClose: 2000 });
            return false;
        }
        if (formDataReset.password_confirmation === '') {
            toast.error('Please password confirmation', { autoClose: 2000 });
            return false;
        }
        if (formDataReset.password_confirmation !== formDataReset.password) {
            toast.error('Please new password and confirm password not matched!', { autoClose: 2000 });
            return false;
        }

        dispatch(ResetPassword(formDataReset));
    }
    useEffect(() => {
        if (ResetPasswordstatus === 'success' && ResetPasswordData?.status?.success === true) {
            toast.success(ResetPasswordData?.message, { autoClose: 2000 });
            window.location.reload()
        } else if (ResetPasswordstatus === 'success' && ResetPasswordData?.status?.success === false) {
            toast.error(ResetPasswordData?.message, { autoClose: 2000 });
        }
    }, [ResetPasswordData, ResetPasswordstatus]);
    const [showPass, setShowPass] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    const socialLinks = [
        {
            Icon: Facebook,
            url: "https://www.facebook.com/profile.php?id=61556636169532",
        },
        {
            Icon: Instagram,
            url: "https://www.instagram.com/ziatravelsofficial/",
        },
        // {
        //   Icon: Twitter,
        //   url: "https://twitter.com/yourpage",
        // },
        {
            Icon: Linkedin,
            url: "https://www.linkedin.com/company/zia-travels/home/",
        },
        {
            Icon: Chrome,
            url: "https://www.google.com",
        },
    ];
    return (
        <>
            {(() => {

                return (
                    <>
                        <div className="min-h-screen font-sans text-slate-800 bg-white">
                            {/* ── Navbar ── */}
                            {/* ── Hero / Login Section ── */}
                            <section className="relative text-white bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/ziatravels/ziaHomeBanner.jpeg')", }} >
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 grid lg:grid-cols-2 gap-12 items-center ">
                                    {/* Login Card */}
                                    {!ShowForgot && (
                                        <div className="bg-white rounded-2xl shadow-2xl p-8 text-slate-800 w-full max-w-md mx-auto lg:mx-0">
                                            <h2 className="text-2xl font-bold text-blue-900 mb-1">Agent Login</h2>
                                            <p className="text-sm text-slate-500 mb-6">Login here to your account as</p>
                                            <form onSubmit={handleSubmit}>
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide">
                                                            Email ID
                                                        </label>
                                                        <input
                                                            type="email"
                                                            id="email"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            className="w-full border border-slate-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide">
                                                            Password
                                                        </label>
                                                        <div className="relative">
                                                            <input
                                                                type={showPass ? "text" : "password"}
                                                                id="password"
                                                                name="password"
                                                                value={formData.password}
                                                                onChange={handleChange}
                                                                className="w-full border border-slate-200 rounded-lg px-4 py-3 pr-12 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={() => setShowPass(!showPass)}
                                                                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-blue-500"
                                                            >
                                                                {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button
                                                    type="submit"
                                                    disabled={status === 'loading'}
                                                    className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg transition-colors duration-200 shadow tracking-widest text-sm"
                                                >
                                                    {status === 'loading' ? 'Logging in...' : 'LOGIN'}
                                                </button>
                                            </form>
                                            <p className="mt-4 text-center text-sm text-slate-500">
                                                Forgot your password?{" "}
                                                <a onClick={() => setShowForgot(!ShowForgot)} className="text-blue-600 cursor-pointer font-semibold hover:underline">
                                                    Reset Here
                                                </a>{" | "}
                                                <a href={"/register"} className="text-blue-600 font-semibold hover:underline">
                                                    Create Account
                                                </a>
                                            </p>
                                        </div>
                                    )}

                                    {ShowForgot && (
                                        <>
                                            <div className="bg-white rounded-2xl shadow-2xl p-8 text-slate-800 w-full max-w-md mx-auto lg:mx-0">
                                                <h2 className="text-2xl font-bold text-blue-900 mb-1">Reset Password</h2>
                                                {ForgotPasswordstatus !== 'success' && (
                                                    <form onSubmit={handleforgotPassword}>
                                                        <div className="mb-4">
                                                            <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide" htmlFor="email">
                                                                Email
                                                            </label>
                                                            <input
                                                                type="email"
                                                                id="email"
                                                                name="email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                required
                                                            />
                                                        </div>

                                                        <div className="flex items-center justify-between mb-6">
                                                            <a onClick={() => setShowForgot(!ShowForgot)} className="text-sm cursor-pointer text-blue-600 hover:underline">
                                                                Login?
                                                            </a>
                                                            <button
                                                                type="submit"
                                                                disabled={ForgotPasswordstatus === 'pendig'}
                                                                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-3 rounded-lg transition-colors duration-200 shadow tracking-widest text-sm"
                                                            >
                                                                {ForgotPasswordstatus === 'pendig' ? 'Please wait...' : 'Submit'}
                                                            </button>
                                                        </div>
                                                    </form>
                                                )}
                                                {ForgotPasswordstatus === 'success' && (
                                                    <form onSubmit={SubmitforgotPassword}>
                                                        <div className="mb-4">
                                                            <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide" htmlFor="email">
                                                                Enter OTP
                                                            </label>
                                                            <input
                                                                type="number"
                                                                id="otp"
                                                                name="otp"
                                                                value={formDataReset.otp}
                                                                onChange={handleChangeResetPassword}
                                                                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                required
                                                            />
                                                        </div>
                                                        <div className="mb-4">
                                                            <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide" htmlFor="password">
                                                                New Password
                                                            </label>
                                                            <div className="relative">
                                                                <input
                                                                    type={showPassword ? "text" : "password"}
                                                                    id="password"
                                                                    name="password"
                                                                    value={formDataReset.password}
                                                                    onChange={handleChangeResetPassword}
                                                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                                                                    required
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                    className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                                                                >
                                                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="mb-4">
                                                            <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide" htmlFor="password">
                                                                Password Confirmation
                                                            </label>
                                                            <div className="relative">
                                                                <input
                                                                    type={showPasswordConfirm ? "text" : "password"}
                                                                    id="password_confirmation"
                                                                    name="password_confirmation"
                                                                    value={formDataReset.password_confirmation}
                                                                    onChange={handleChangeResetPassword}
                                                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                                                                    required
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                                                    className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                                                                >
                                                                    {showPasswordConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                                                                </button>
                                                            </div>
                                                        </div>


                                                        <small className="text-sm text-gray-600 text-right">
                                                            OTP has been shared with your mobile ending in {maskPhone(formDataReset?.phone, 2)}
                                                        </small>
                                                        <div className="flex items-center justify-between mb-6">

                                                            <a onClick={() => setShowForgot(!ShowForgot)} className="text-sm cursor-pointer text-blue-600 hover:underline">
                                                                Login?
                                                            </a>

                                                            <button
                                                                type="submit"
                                                                disabled={ResetPasswordstatus === 'pendig'}
                                                                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-3 rounded-lg transition-colors duration-200 shadow tracking-widest text-sm"
                                                            >
                                                                {ResetPasswordstatus === 'pendig' ? 'Please wait...' : 'Submit'}
                                                            </button>
                                                        </div>

                                                    </form>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    {/* Hero Text */}
                                    <div className="text-center lg:text-left">
                                        <div className="inline-flex items-center gap-2 bg-blue-500/30 border border-blue-400/40 rounded-full px-4 py-1 text-xs font-semibold uppercase tracking-widest mb-6">
                                            <span className="w-2 h-2 bg-blue-300 rounded-full animate-pulse" />
                                            Trusted Since 2015
                                        </div>
                                        <h1 className="text-4xl sm:text-5xl xl:text-6xl font-extrabold leading-tight mb-6">
                                            Power Your Travel Business with Better Flight Fares
                                        </h1>
                                        <p className="text-blue-200 text-lg mb-8 max-w-lg mx-auto lg:mx-0">
                                            Access competitive B2B flight fares with fast search, easy booking, and reliable ticketing — built for travel agents across India.
                                        </p>
                                        <div className="flex flex-wrap gap-4 justify-center lg:justify-start text-sm">
                                            {[
                                                { icon: Search, text: "Quick Search" },
                                                { icon: BadgeDollarSign, text: "High Commission" },
                                                { icon: ShieldCheck, text: "100% Reliable" },
                                                { icon: Zap, text: "Instant Booking" },
                                            ].map(({ icon: Icon, text }) => (
                                                <div
                                                    key={text}
                                                    className="flex items-center gap-2 bg-white/10 backdrop-blur rounded-full px-4 py-2"
                                                >
                                                    <CheckCircle2 className="text-blue-300 w-4 h-4" />
                                                    <span>{text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* ── Services ── */}
                            <section className="py-16 bg-slate-50">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                    <div className="text-center mb-12">
                                        <h2 className="text-3xl sm:text-4xl font-extrabold text-blue-900 mb-3">Our Services</h2>
                                        <p className="text-slate-500 max-w-xl mx-auto text-sm">
                                            Everything your travel business needs — under one roof.
                                        </p>
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                        {services.map(({ icon: Icon, title, desc }) => (
                                            <div
                                                key={title}
                                                className="group bg-white rounded-2xl border border-blue-100 p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                                            >
                                                <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center mb-5 group-hover:bg-blue-700 transition-colors">
                                                    <Icon className="text-white w-7 h-7" />
                                                </div>
                                                <h3 className="font-bold text-blue-900 text-lg mb-2">{title}</h3>
                                                <p className="text-slate-500 text-sm leading-relaxed">{desc}</p>
                                            </div>
                                        ))}

                                        {/* CTA card */}
                                        <div className="bg-gradient-to-br from-blue-700 to-blue-500 rounded-2xl p-6 flex flex-col justify-between text-white shadow-lg">
                                            <div>
                                                <h3 className="font-extrabold text-xl mb-3">Ready to grow?</h3>
                                                <p className="text-blue-100 text-sm leading-relaxed">
                                                    Join thousands of agents already using {getSiteName()} to scale their travel business.
                                                </p>
                                            </div>
                                            <a
                                                href={"/register"}
                                                className="mt-6 inline-flex items-center gap-2 bg-white text-blue-700 font-bold text-sm px-5 py-2.5 rounded-full hover:bg-blue-50 transition w-fit"
                                            >
                                                Get Started <ChevronRight size={16} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* ── Why Holidayfly ── */}
                            <section className="py-16 sm:py-20 bg-white">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">

                                    {/* Left – About Zia Travels */}
                                    <div>
                                        <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-5">
                                            About Zia Travels
                                        </span>

                                        <h2 className="text-3xl sm:text-4xl font-extrabold text-blue-900 mb-6 leading-tight">
                                            Your Trusted Partner for
                                            <span className="text-blue-600"> B2B Flight Bookings</span>
                                        </h2>

                                        <p className="text-slate-600 text-sm sm:text-base leading-relaxed mb-4">
                                            Zia Travels is a trusted B2B flight booking partner for travel agents across India, providing access to competitive airfares and a seamless booking experience through our dedicated travel portal.
                                        </p>

                                        <p className="text-slate-600 text-sm sm:text-base leading-relaxed mb-8">
                                            Our platform is designed to make flight booking faster, simpler, and more efficient for travel businesses. From real-time flight search to quick ticketing, we empower travel agents to find suitable fares, serve their customers confidently, and grow their businesses.
                                        </p>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            {highlights.map(({ icon: Icon, label }) => (
                                                <div
                                                    key={label}
                                                    className="flex items-center gap-3 bg-blue-50 rounded-xl p-4 border border-blue-100 hover:border-blue-300 hover:shadow-sm transition-all duration-200"
                                                >
                                                    <div className="w-11 h-11 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                                                        <Icon className="text-white w-5 h-5" />
                                                    </div>
                                                    <span className="text-sm font-semibold text-blue-950">
                                                        {label}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Right – Why Choose Zia Travels */}
                                    <div className="relative bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 rounded-2xl p-6 sm:p-8 text-white shadow-xl overflow-hidden">
                                        {/* Decorative elements */}
                                        <div className="absolute -top-16 -right-16 w-40 h-40 bg-blue-500/20 rounded-full blur-2xl pointer-events-none" />
                                        <div className="absolute -bottom-16 -left-16 w-40 h-40 bg-cyan-400/10 rounded-full blur-2xl pointer-events-none" />

                                        <div className="relative">
                                            <span className="text-blue-300 text-xs font-bold uppercase tracking-widest">
                                                Why Choose Us
                                            </span>

                                            <h3 className="text-2xl font-extrabold mt-3 mb-3">
                                                Everything Travel Agents Need
                                            </h3>

                                            <p className="text-blue-100/80 text-sm leading-relaxed mb-7">
                                                Smart booking tools and dependable support to help your travel business move forward.
                                            </p>

                                            <div className="space-y-3">
                                                {whyUs.map(({ icon: Icon, label }) => (
                                                    <div
                                                        key={label}
                                                        className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-xl px-4 py-4 hover:bg-white/10 hover:border-blue-400/40 transition-all duration-200"
                                                    >
                                                        <div className="w-11 h-11 bg-blue-500/20 border border-blue-400/20 rounded-xl flex items-center justify-center flex-shrink-0">
                                                            <Icon className="text-blue-300 w-5 h-5" />
                                                        </div>

                                                        <span className="text-sm sm:text-base font-medium leading-snug">
                                                            {label}
                                                        </span>

                                                        <svg
                                                            className="w-4 h-4 text-blue-300 ml-auto flex-shrink-0"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M9 5l7 7-7 7"
                                                            />
                                                        </svg>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="mt-7 pt-6 border-t border-white/10 flex items-center gap-3">
                                                <div className="w-10 h-10 rounded-full bg-green-400/15 flex items-center justify-center flex-shrink-0">
                                                    <svg
                                                        className="w-5 h-5 text-green-400"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M5 13l4 4L19 7"
                                                        />
                                                    </svg>
                                                </div>

                                                <div>
                                                    <p className="text-sm font-bold text-white">
                                                        Built for Travel Agents
                                                    </p>
                                                    <p className="text-xs text-blue-200 mt-1">
                                                        Search, book, and manage flights with confidence.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </section>

                            {/* ── Stats Banner ── */}
                            <section className="bg-gradient-to-r from-blue-700 to-blue-500 py-10">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-white text-center">
                                    {[
                                        { value: "10,000+", label: "Travel Agents" },
                                        { value: "50+", label: "Airlines Integrated" },
                                        { value: "500+", label: "Hotel Partners" },
                                        { value: "Since 2015", label: "In the Industry" },
                                    ].map(({ value, label }) => (
                                        <div key={label}>
                                            <div className="text-3xl font-extrabold">{value}</div>
                                            <div className="text-blue-200 text-sm mt-1">{label}</div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* ── Footer ── */}
                            <footer className="bg-blue-950 text-slate-300 pt-14 pb-6">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
                                        {/* Brand */}
                                        <div>
                                            <div className="flex items-center gap-2 mb-4">
                                                <Link to="/">
                                                    <img src={"/" + getSiteName() + "/logo_footer.png"} alt="Logo" className="h-10" />
                                                </Link>
                                            </div>
                                            <p className="text-xs text-slate-400 mb-1 font-semibold uppercase tracking-wide">
                                                {getSiteName()}
                                            </p>
                                            <p className="text-xs text-slate-500 mb-5">A TRAVEL COMPANY</p>
                                            {/* <ul className="space-y-2 text-sm">
                          <li className="flex items-start gap-2">
                            <Phone size={14} className="text-blue-400 mt-0.5 flex-shrink-0" />
                            011-45023178
                          </li>
                          <li className="flex items-start gap-2">
                            <Mail size={14} className="text-blue-400 mt-0.5 flex-shrink-0" />
                            support@{getSiteName()}.com
                          </li>
                          <li className="flex items-start gap-2">
                            <MapPin size={14} className="text-blue-400 mt-0.5 flex-shrink-0" />
                            <span className="text-xs leading-relaxed">
                              DGL-216, DLF Galleria Mall, Mayur Vihar phase -1 Extension, New Delhi - 110091
                            </span>
                          </li>
                        </ul> */}

                                            {/* Social */}
                                            {/* Social */}
                                            <div className="flex gap-3 mt-5">
                                                {socialLinks.map(({ Icon, url }, i) => (
                                                    <a
                                                        key={i}
                                                        href={url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label={`Social link ${i + 1}`}
                                                        className="w-9 h-9 rounded-full bg-blue-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
                                                    >
                                                        <Icon size={16} className="text-white" />
                                                    </a>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Company */}
                                        <div>
                                            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-widest">Company</h4>
                                            <ul className="space-y-2">
                                                {footerCompany.map((v, k) => (
                                                    <li key={k}>
                                                        <a href={v.href} className="text-sm text-slate-400 hover:text-blue-400 flex items-center gap-1 transition-colors">
                                                            <ChevronRight size={13} /> {v.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                        {/* Product */}
                                        <div>
                                            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-widest">Product</h4>
                                            <ul className="space-y-2">
                                                {footerProduct.map((v, l) => (
                                                    <li key={l}>
                                                        <a href={v.href} className="text-sm text-slate-400 hover:text-blue-400 flex items-center gap-1 transition-colors">
                                                            <ChevronRight size={13} /> {v.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                        {/* Policies */}
                                        <div>
                                            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-widest">Policies & Terms</h4>
                                            <ul className="space-y-2">
                                                {footerPolicies.map((v, l) => (
                                                    <li key={l}>
                                                        <a href={v.href} className="text-sm text-slate-400 hover:text-blue-400 flex items-center gap-1 transition-colors">
                                                            <ChevronRight size={13} /> {v.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    {/* <div className="border-t border-blue-900 pt-5 text-center text-xs text-slate-500">
                      Copyright 2026, {getSiteName()}.com. All rights reserved
                    </div> */}
                                </div>
                            </footer>
                        </div>

                    </>
                );

            })()}
        </>
    );
}

